import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getRatePlans } from 'modules/settings/api';

export const useQueryRatePlans = (excludeUnits: boolean) => {
  return useQuery(QUERY_KEYS.SETTINGS_RATE_PLANS, () => getRatePlans(excludeUnits));
};
